<template>
  <div c_name="HomePC">
    <Swiper :datas="swiperData" :opts="''" @events="swiperEvents" />
    <div class="home_game">
      <div class="home_game_1">GAME PARADISE</div>
      <div class="home_game_2">游戏乐园</div>
    </div>

    <div class="home_games_but">
      <template v-for="(item, index) in games">
        <span :class="{game_but: item.name != nowGame.name, game_now: item.name == nowGame.name}"
         :key="index" @click="onClickGame(index)">{{item.name}}</span>
        <span class="gmae_line" :key="'x' + index" v-show="index < gameNum - 1">|</span>
      </template>
      <div />
    </div>
    <div class="games_imgs">
      <GameAboutPC :datas="nowGame" :opts="''" @events="gameEvents" />
    </div>

    <div class="page_space home_huodong" :style="huodongBgStyle">
      <div class="huodong_title">
        <img src="@/assets/huodong_dot.png" alt="">
        新闻资讯
      </div>
      <div class="huodong_item" v-for="(item, index) in news" :key="index">
        <img src="@/assets/huodong_dot2.png" alt="">
        <a :href="item.router" target="_blank">{{item.title}}</a>
      </div>
    </div>

    <div class="page_space home_huodong" :style="huodongBgStyle">
      <div class="huodong_title">
        <img src="@/assets/huodong_dot.png" alt="">
        精彩活动
      </div>
      <div class="huodong_item" v-for="(item, index) in huodongs" :key="index">
        <img src="@/assets/huodong_dot2.png" alt="">
        <router-link :to="item.router">{{item.title}}</router-link>
      </div>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
import Swiper from '@/components/common/Swiper.vue'
import GameAboutPC from '@/components/GameAboutPC.vue'
import tools from '@/tools/tools'

export default {
  name: 'HomePC',
  components: {
    Swiper,
    GameAboutPC
  },
  data: () => {
    return {
      nowGame: {}
    }
  },
  created () {
    this.nowGame = this.games[0]
  },
  methods: {
    // 轮播事件返回
    swiperEvents (vtype, vitem, vid) {
      console.log(vtype, vitem, vid)
    },
    onClickGame (vid) {
      this.nowGame = this.games[parseInt(vid)]
    },
    gameEvents (vtype, vitem) {
      console.log('HomePc')
      console.log(vtype, vitem)
      if (vtype === 'go_h5') {
        tools.openH5Url(vitem.h5Url)
      } else {
        tools.iosDoLocation(this.$store.getters.getDownNow(vitem.downKey))
      }
    }
  },
  computed: {
    games () {
      return this.$store.state.configs.games
    },
    gameNum () {
      return this.games.length
    },
    swiperData () {
      return this.$store.state.configs.swiperData_pc
    },
    huodongs () {
      return this.$store.state.configs.huodongs
    },
    news () {
      return this.$store.state.configs.news
    },
    huodongBgStyle () {
      return {
        'background-image': 'url(' + require('@/assets/home_huodong.png') + ')'
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.home_games_but {
    margin: 1rem 0;
    font-size: 1rem;

}

.game_but {
  color: rgba(153, 153, 153, 1);
  padding: 0.2rem 0.1rem;
  border-bottom: 0.1rem #fff solid;
  cursor: pointer;
}
.game_now {
  color: #37a1ff;
  padding: 0.2rem 0.1rem;
  border-bottom: 0.1rem #37a1ff solid;
  cursor: pointer;
}
.gmae_line {
  color: rgba(215, 215, 215, 1);
  font-size: 0.5rem;
  padding: 0 0.5rem;
}
.home_huodong {
  margin-bottom: 1.2rem;
  text-align: left;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding-bottom: 2rem;
}
.huodong_title {
  padding: 0.4rem;
  padding-left: 2rem;
  color: #333;
  font-size: 0.9rem;
  border-bottom: 1px rgba(0, 0, 0, 0.04) solid;
  margin-bottom: 0.3rem;
}
.huodong_item {
  padding: 0.4rem;
  padding-left: 2rem;
  font-size: 0.6rem;
}
.huodong_item img {
  width: 0.5rem;
  margin-right: 0.3rem;
}
.huodong_item a {
  color: #666;
  text-decoration: none;
}
.home_game {
  margin-bottom: 30px;
}
.home_game_1 {
  font-size: 46px;
  color: #eee;
}
.home_game_2 {
  position: absolute;
  width: 1200px;
  margin-top: -28px;
  font-size: 32px;
}
</style>
